import React from "react";
import { NavLink } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Link, Users } from "lucide-react";

/**
 * Affiliate URL Summary Widget
 * Modernized with shadcn components - Shows custom URLs and affiliate signups
 */
function Affiliate_Url_summary({ customurlno, signedupno }) {
    return (
        <Card>
            <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-lg font-semibold text-brand-dark flex items-center gap-2">
                    <Link className="h-5 w-5 text-brand-accent" />
                    Affiliate URLs
                </CardTitle>
                <NavLink to="/affiliate">
                    <Button variant="ghost" size="sm" className="text-brand-accent hover:text-brand-accent/80 hover:bg-white">
                        Affiliate URLs
                    </Button>
                </NavLink>
            </CardHeader>
            <CardContent>
                <div className="grid grid-cols-2 gap-4">
                    <div className="space-y-1">
                        <p className="text-sm font-medium text-brand-dark/70">Custom URLs</p>
                        <p className="text-2xl font-bold text-brand-dark">{customurlno || 0}</p>
                    </div>
                    <div className="space-y-1">
                        <p className="text-sm font-medium text-brand-dark/70 flex items-center gap-1">
                            <Users className="h-4 w-4" />
                            Affiliates Signed up
                        </p>
                        <p className="text-2xl font-bold text-brand-dark">{signedupno || 0}</p>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}

export default Affiliate_Url_summary;
